import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { environment } from "../../environments/environment";

@Injectable({ providedIn: "root" })
export class ScholasticPeriodsService {
    constructor(private http: HttpClient) { }

    getCurrentSemester(schoolId: number) {
        return this.http.get<any>(`${environment.apiUrl}/ScholasticPeriods/GetCurrentSemesterBySchool?schoolId=${schoolId}`);
    }
}